import { StepCard } from '../pages/check-pets-chip/check-pets-chip.component';

export const getCheckChipSteps = (phoneNumber: string): StepCard[] => [
  {
    title: 'Your chip is registered with identi',
    text: ` Congratulations your pet has an identichip! Login via our website, app or call our contact centre on ${phoneNumber} to check their details.`,
    button: 'Login',
  },
  {
    title: 'Your chip is registered with another database',
    text: `Contact your database to make sure your pet's details are up to date.`,
    secondaryText: `Don't forget! You can always switch to identi and take advantage of our exclusive pet protection plans - `,
    link: 'Learn more here',
    linkRedirect:
      'https://identicare.zendesk.com/hc/en-gb/articles/12334630192541-How-do-I-transfer-from-another-database-to-identibase',
  },
  {
    title: 'Your chip is not registered with a UK database',
    text: `This can happen if your pet's chip has not been sourced from a UK provider. Not to worry! Call us on ${phoneNumber} to get the chip registered with identi.`,
  },
  {
    title: 'Your chip is registered with two databases',
    text: `In some cases, the chip checker may list two or more different databases. For the purpose of pet welfare, it is recommended that your pet's details are only held on a single <b>DEFRA approved</b> database.`,
  },
];
